import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import classNames from "classnames";

import { addBundleToCart } from "../../../../redux/cart";

import { isValidUrl } from "../../../../helpers/isValidUrl";

import QuantityControls from "../../../QuantityControls/QuantityControls";
import MechanicBasedView from "../../../MechanicBasedView";

import logo from "../../../../assets/images/logo.png";

const BundleCard = ({ bundle }) => {
  const cart = useSelector((state) => state.cart);

  const location = useLocation();
  const { pathname } = location;

  const dispatch = useDispatch();

  const bundleAddedToCartHandler = (bundle) => {
    const { skuList, id, discount, priceBeforeDiscount, name } = bundle;

    const skuListToAdd = skuList.map(
      ({ skuId, suggestedSellingPrice, images, ...rest }) => ({
        id: skuId,
        inventoryPrice: suggestedSellingPrice,
        images: images.map((img) => ({ imageUrl: img })),
        ...rest,
      })
    );

    const bundleToAdd = {
      id,
      discount,
      priceBeforeDiscount,
      name,
      quantity: 1,
      skuList: skuListToAdd,
    };

    dispatch(addBundleToCart(bundleToAdd));
  };

  const getBundleFromCart = (bundleId) => {
    return cart.bundles.find((cartItem) => cartItem.id === bundleId);
  };

  const [expandedDetails, setExpandedDetails] = useState(false);

  function toggleDetailsView() {
    setExpandedDetails(!expandedDetails);
  }

  const bundleImages = bundle.skuList.map((sku) => sku.images).flat();

  return (
    <article className="min-w-0 min-h-fit border border-light-gray rounded-lg py-4 flex flex-col item-center gap-4">
      <div className="flex justify-center items-center pt-4">
        {bundleImages
          .filter((_, index) => index < 3)
          .map((image, index) => (
            <div
              key={index}
              className={classNames(
                `h-24 w-24 rounded-full overflow-hidden border border-gray-200`,
                `z-${index}0`,
                { "-mr-3": index !== 0 }
              )}
            >
              <img
                src={isValidUrl(image) ? image : logo}
                alt="bundleSkuImage"
                className="h-full w-full object-cover"
              />
            </div>
          ))}

        {bundleImages.length > 3 && (
          <div
            className={classNames(
              `flex justify-center items-center h-24 w-24`,
              `font-bold text-2xl`,
              `rounded-full border border-gray-200 bg-gray-50`,
              `z-40 -mr-3`
            )}
          >
            <span>{`+${bundleImages.length - 3}`}</span>
          </div>
        )}
      </div>

      <div className="flex justify-center">{bundle.name}</div>

      <MechanicBasedView>
        <div className="flex justify-center">
          <span className="bundle-old-price ml-5">
            {bundle.priceBeforeDiscount} {"جم "}
          </span>{" "}
          <span className="text-#216DA6 font-extrabold">
            {bundle.priceBeforeDiscount - bundle.discount} {"جم "}
          </span>
        </div>
      </MechanicBasedView>

      <div className="pr-2">
        <button
          className="bg-transparent hover:underline inline-flex items-center p-2"
          onClick={toggleDetailsView}
        >
          {expandedDetails ? (
            <>
              <span>إخفاء التفاصيل</span>
              <IoIosArrowUp />
            </>
          ) : (
            <>
              <span>عرض التفاصيل </span> <IoIosArrowDown />{" "}
            </>
          )}
        </button>
      </div>

      {expandedDetails && (
        <div className="bg-gray-100 p-2">
          <p className="text-base font-bold mb-3">هذه المجموعة تتكون من:</p>
          <ul className="list-disc ">
            {bundle?.skuList.map((sku) => (
              <Link
                key={sku.skuId}
                className="block text-sm font-normal hover:text-blue-400 mr-8 mb-2"
                to={`/product/${sku.skuId}`}
                state={{ from: pathname }}
              >
                <li>{`(${sku.quantity})  ${sku.commercialName}`}</li>
              </Link>
            ))}
          </ul>
        </div>
      )}

      <MechanicBasedView>
        <div className="px-4 mt-auto flex justify-center">
          {getBundleFromCart(bundle.id) ? (
            <QuantityControls
              product={getBundleFromCart(bundle.id)}
              removeOnLessOne
              isBundle
            />
          ) : (
            <button
              className="px-4 py-3 rounded-lg bg-dark-blue text-white text-center w-full disabled:bg-light-gray disabled:cursor-not-allowed"
              onClick={() => bundleAddedToCartHandler(bundle)}
            >
              أضف الي العربة
            </button>
          )}
        </div>
      </MechanicBasedView>
    </article>
  );
};
export default BundleCard;
